import React from 'react';

import * as S from '../BreadCrumb/BreadCrumb.styles';

import ThankYouSuccessImg from '../../../../Icons/Partner/ThankYouSuccess';
import ThankYouFailSvg from '../../../../Icons/Partner/ThankYouFail';
import ThankYouPendingImg from '../../../../Icons/Partner/ThankYouPending';

const BreadCrumb = ({statusInfo, navigateToMyTrips}) => {

  const getStatusImg = (key) => {
    switch(key) {
      case 'blue':
        return <ThankYouSuccessImg />;
      case 'red':
        return <ThankYouFailSvg />;
      case 'yellow':
        return <ThankYouPendingImg />;
      default:
        return <ThankYouSuccessImg />;
    }
  }

  return(
    <S.BookingStatusOuterWrap status={statusInfo.statusFlag}>
      <S.BookingStatusInnerWrap>
        <S.BookingStatusHeadText>{statusInfo.header}</S.BookingStatusHeadText>
        <S.BookingStatusInfoWrap>
          <S.BookingEmailInfoText>{statusInfo.subHeader}</S.BookingEmailInfoText>
          <S.BookingEmailInfoText>Visit manage booking to track, edit or share.</S.BookingEmailInfoText>
        </S.BookingStatusInfoWrap>
        <S.BookingIdWrap>
          <S.BookingIdText>Booking ID: <span>{statusInfo.bookingId}</span></S.BookingIdText>
        </S.BookingIdWrap>
        <S.ManagerBookingBtnWrap onClick={() => navigateToMyTrips()}>
          <S.ManageBtn>Manage Booking</S.ManageBtn>
        </S.ManagerBookingBtnWrap>
      </S.BookingStatusInnerWrap>
      <S.ThanYouStatusImgWrap>
        {getStatusImg(statusInfo.statusFlag)}
      </S.ThanYouStatusImgWrap>
    </S.BookingStatusOuterWrap>
  )
};

export default BreadCrumb;
